import React from "react";
import "./loader.css";
const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader">
        <div className="rectangle"></div>
      </div>
    </div>
  );
};

export default Loader;
